import { filter } from 'lodash';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { IUserInfo ,AuthService} from '../shared/core/index';
import { ReportGenerate } from './reports-generate.model';
import { IReportItem } from './reports-Item.model';
import { ReportBuilder } from './reports-builder.model';
import { retry } from 'rxjs/operator/retry';
import { ILookup } from '../shared/lookup';
import { HttpService } from '../shared/core/http.service';


@Injectable()
export class ReportsService {

    private _userInfo: IUserInfo;
    private _reportsUrl = new URL('reports', process.env.API_URL).toString();
    
    constructor(private _http: Http, private _httpService: HttpService, private authService: AuthService) {
        this.authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }
    downloadReport(url: string): Observable<Blob> {
        return this._http.get(url, { responseType: ResponseContentType.Blob })
            .map(
            (res) => {
                return new Blob([res.blob()], { type: 'application/pdf' })
            })
            .do(data => data)
            .catch(this.handleError);;
    }

    generateReports(searchData: ReportBuilder): Observable<string> {
        searchData.requestType ='GenerateReports';
        console.log('calling getReport() from ' + this._reportsUrl);
        var body = JSON.stringify(searchData);
        console.log(body);
        if(body.indexOf("<") !== -1 || body.indexOf(">") !== -1){
            console.log('AntiXssMiddleware angled brackets ("<", ">") in your input(s).');
            return Observable.throw("AntiXssMiddleware");
        }
        return this._httpService.httpPost(this._reportsUrl, body)
        .map((response: Response) => {
            return '';
        })
            .do(data => data)
            .catch(this.handleError);
    }

    getTags(searchData: ReportBuilder): Observable<ILookup[]> {
        searchData.requestType ='GetTags';
        console.log('calling getReport() from ' + this._reportsUrl);
        var body = JSON.stringify(searchData);
        return this._httpService.httpPost(this._reportsUrl, body)
        .map((response: Response) => {
            return response.json();
        })
            .do(data => data)
            .catch(this.handleError);
    }
    
    getReportsList(requestData: ReportBuilder ):Observable<ReportBuilder> {
        console.log('calling getReportsList() from ' + this._reportsUrl);
        requestData.requestType ='GetReportsList';
        var body = JSON.stringify(requestData);
        return this._httpService.httpPost(this._reportsUrl, body)
        .map((response: Response) => {
            return this.mapListSearchData(response);
        })
            .do(data => data)
            .catch(this.handleError);
    }

    deleteReport(id: string): Observable<boolean> {

        if (!id) {
            console.error('cannot delete an empty report, try passing the id...');
            return Observable.of(false);
        }

        let url = new URL(id, this._reportsUrl + '/').toString();
        console.log('deleteReport() at ' + url + ' for report: ' + JSON.stringify(id));

        return this._httpService.httpDelete(url)
            .map((p: Response) => {
                //let body= p.json();
                //return body || {}
                console.log('deleteReport');
                return Observable.of(true);
            })
            .catch(this.handleError);

    }

    getReportsItem(requestData: ReportBuilder ):Observable<IReportItem> {
        console.log('calling getReportsItem() from ' + this._reportsUrl);
        requestData.requestType ='GetReport';
        var body = JSON.stringify(requestData);
        return this._httpService.httpPost(this._reportsUrl, body)
        .map((response: Response) => {
            return this.toReportItem(response.json());
        })
            .do(data => data)
            .catch(this.handleError);
    }
    mapListSearchData(response: Response): ReportBuilder {
        var ret = this.toListSearchData(response.json());
        return ret;
    }
    toListSearchData(data: any): ReportBuilder {
        if (data) {
            console.log(data);
            let listSearchData: ReportBuilder = new ReportBuilder();
            listSearchData.pageStartIndex = data.PageStartIndex;
            listSearchData.pageSize = data.PageSize;
            listSearchData.totalNumberOfRecords = data.TotalNumberOfRecords;
            listSearchData.reportPrivilegedNotes=data.ReportPrivilegedNotes;
            listSearchData.reports = [];
            if (data.ResultSet) {
                data.ResultSet.forEach(element => {
                    listSearchData.reports.push(this.toReportItem(element));
                });
            }
            return listSearchData;
        }
    }
    toReportItem(data: any):IReportItem{
        let retValue: IReportItem = new IReportItem();
        retValue.createdDate = data.CreatedDate;
        retValue.createdBy = data.CreatedBy;
        retValue.errorMessage = data.ErrorMessage;
        retValue.reportName = data.ReportName;
        retValue.reportStatus = data.ReportStatus;
        retValue.reportUrl = data.ReportUrl;
        retValue.reportId = data.ReportId;
        retValue.status = data.Status;
        retValue.sortedBy = data.SortedBy;
        retValue.searchBy = data.SearchBy;
        retValue.searchByValue = data.SearchByValue;
        retValue.sortDirection = data.SortDirection;
        retValue.projectId = data.ProjectId;
        retValue.restrictionType = data.RestrictionType;
        retValue.customHeader=data.customHeader;
        retValue.isCustomHeaderSelected=data.customHeader;
        retValue.selectedIDs=data.SelectedIDs;
        retValue.projectName=data.ProjectName;
        retValue.status=data.Status;
        return retValue;
    }
    getFilters(): any {
        return {};
    }

    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error('reportService.handleError(...() >>> There has been an error while calling api, error:', error);

        return Observable.throw(error || 'Server error');
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/reports/reports.service.ts